/*
 * This utility is a clever but hacky hack. In react-native we use imported SVGs to
 * render icons. We can directly set the SVG's color so that the icon color can be set via
 * react props. However, on (nextjs) web, we load the svgs via <img> which doesn't allow for setting
 * currentColor. As a workaround, we compute a css filter that approximates the desired color value
 *
 * Taken from https://stackoverflow.com/a/64844454/906283
 */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import ColorParser from "color";
function parseColorToRgb(input) {
    var colorInstance = new ColorParser(input);
    return new RgbColor(colorInstance.red(), colorInstance.green(), colorInstance.blue());
}
function clampRgbPart(value) {
    if (value > 255) {
        return 255;
    }
    if (value < 0) {
        return 0;
    }
    return value;
}
var RgbColor = /*#__PURE__*/ function() {
    "use strict";
    function RgbColor(red, green, blue) {
        _class_call_check(this, RgbColor);
        _define_property(this, "red", void 0);
        _define_property(this, "green", void 0);
        _define_property(this, "blue", void 0);
        this.red = red;
        this.green = green;
        this.blue = blue;
    }
    _create_class(RgbColor, [
        {
            key: "toString",
            value: function toString() {
                return "rgb(".concat(Math.round(this.red), ", ").concat(Math.round(this.green), ", ").concat(Math.round(this.blue), ")");
            }
        },
        {
            key: "set",
            value: function set(r, g, b) {
                this.red = clampRgbPart(r);
                this.green = clampRgbPart(g);
                this.blue = clampRgbPart(b);
            }
        },
        {
            key: "hueRotate",
            value: function hueRotate() {
                var angle = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                angle = angle / 180 * Math.PI;
                var sin = Math.sin(angle);
                var cos = Math.cos(angle);
                this.multiply([
                    0.213 + cos * 0.787 - sin * 0.213,
                    0.715 - cos * 0.715 - sin * 0.715,
                    0.072 - cos * 0.072 + sin * 0.928,
                    0.213 - cos * 0.213 + sin * 0.143,
                    0.715 + cos * 0.285 + sin * 0.14,
                    0.072 - cos * 0.072 - sin * 0.283,
                    0.213 - cos * 0.213 - sin * 0.787,
                    0.715 - cos * 0.715 + sin * 0.715,
                    0.072 + cos * 0.928 + sin * 0.072
                ]);
            }
        },
        {
            key: "grayscale",
            value: function grayscale() {
                var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                this.multiply([
                    0.2126 + 0.7874 * (1 - value),
                    0.7152 - 0.7152 * (1 - value),
                    0.0722 - 0.0722 * (1 - value),
                    0.2126 - 0.2126 * (1 - value),
                    0.7152 + 0.2848 * (1 - value),
                    0.0722 - 0.0722 * (1 - value),
                    0.2126 - 0.2126 * (1 - value),
                    0.7152 - 0.7152 * (1 - value),
                    0.0722 + 0.9278 * (1 - value)
                ]);
            }
        },
        {
            key: "sepia",
            value: function sepia() {
                var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                this.multiply([
                    0.393 + 0.607 * (1 - value),
                    0.769 - 0.769 * (1 - value),
                    0.189 - 0.189 * (1 - value),
                    0.349 - 0.349 * (1 - value),
                    0.686 + 0.314 * (1 - value),
                    0.168 - 0.168 * (1 - value),
                    0.272 - 0.272 * (1 - value),
                    0.534 - 0.534 * (1 - value),
                    0.131 + 0.869 * (1 - value)
                ]);
            }
        },
        {
            key: "saturate",
            value: function saturate() {
                var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                this.multiply([
                    0.213 + 0.787 * value,
                    0.715 - 0.715 * value,
                    0.072 - 0.072 * value,
                    0.213 - 0.213 * value,
                    0.715 + 0.285 * value,
                    0.072 - 0.072 * value,
                    0.213 - 0.213 * value,
                    0.715 - 0.715 * value,
                    0.072 + 0.928 * value
                ]);
            }
        },
        {
            key: "multiply",
            value: function multiply(matrix) {
                var newR = clampRgbPart(this.red * matrix[0] + this.green * matrix[1] + this.blue * matrix[2]);
                var newG = clampRgbPart(this.red * matrix[3] + this.green * matrix[4] + this.blue * matrix[5]);
                var newB = clampRgbPart(this.red * matrix[6] + this.green * matrix[7] + this.blue * matrix[8]);
                this.red = newR;
                this.green = newG;
                this.blue = newB;
            }
        },
        {
            key: "brightness",
            value: function brightness() {
                var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                this.linear(value);
            }
        },
        {
            key: "contrast",
            value: function contrast() {
                var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                this.linear(value, -(0.5 * value) + 0.5);
            }
        },
        {
            key: "linear",
            value: function linear() {
                var slope = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, intercept = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this.red = clampRgbPart(this.red * slope + intercept * 255);
                this.green = clampRgbPart(this.green * slope + intercept * 255);
                this.blue = clampRgbPart(this.blue * slope + intercept * 255);
            }
        },
        {
            key: "invert",
            value: function invert() {
                var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                this.red = clampRgbPart((value + this.red / 255 * (1 - 2 * value)) * 255);
                this.green = clampRgbPart((value + this.green / 255 * (1 - 2 * value)) * 255);
                this.blue = clampRgbPart((value + this.blue / 255 * (1 - 2 * value)) * 255);
            }
        },
        {
            key: "applyFilters",
            value: function applyFilters(filters) {
                this.set(0, 0, 0);
                this.invert(filters[0] / 100);
                this.sepia(filters[1] / 100);
                this.saturate(filters[2] / 100);
                this.hueRotate(filters[3] * 3.6);
                this.brightness(filters[4] / 100);
                this.contrast(filters[5] / 100);
            }
        },
        {
            key: "hsl",
            value: function hsl() {
                // Code taken from https://stackoverflow.com/a/9493060/2688027, licensed under CC BY-SA.
                var r = this.red / 255;
                var g = this.green / 255;
                var b = this.blue / 255;
                var max = Math.max(r, g, b);
                var min = Math.min(r, g, b);
                var h, s, l = (max + min) / 2;
                if (max === min) {
                    h = s = 0;
                } else {
                    var d = max - min;
                    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                    switch(max){
                        case r:
                            h = (g - b) / d + (g < b ? 6 : 0);
                            break;
                        case g:
                            h = (b - r) / d + 2;
                            break;
                        case b:
                            h = (r - g) / d + 4;
                            break;
                    }
                    h /= 6;
                }
                return {
                    h: h * 100,
                    s: s * 100,
                    l: l * 100
                };
            }
        }
    ]);
    return RgbColor;
}();
var reusedColor = new RgbColor(0, 0, 0);
function formatFilterValue(value) {
    var multiplier = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    return Math.round(value * multiplier);
}
function convertFiltersListToCSSFilter(filters) {
    // function fmt(idx: number, multiplier = 1) {
    //   return Math.round(filters[idx] * multiplier);
    // }
    var _filters = _sliced_to_array(filters, 6), invert = _filters[0], sepia = _filters[1], saturate = _filters[2], hueRotate = _filters[3], brightness = _filters[4], contrast = _filters[5];
    return "invert(".concat(formatFilterValue(invert), "%) sepia(").concat(formatFilterValue(sepia), "%) saturate(").concat(formatFilterValue(saturate), "%) hue-rotate(").concat(formatFilterValue(hueRotate, 3.6), "deg) brightness(").concat(formatFilterValue(brightness), "%) contrast(").concat(formatFilterValue(contrast), "%)");
}
function calculateLossForFilters(filters, targetColor, targetHSL) {
    reusedColor.applyFilters(filters);
    var actualHSL = reusedColor.hsl();
    return Math.abs(reusedColor.red - targetColor.red) + Math.abs(reusedColor.green - targetColor.green) + Math.abs(reusedColor.blue - targetColor.blue) + Math.abs(actualHSL.h - targetHSL.h) + Math.abs(actualHSL.s - targetHSL.s) + Math.abs(actualHSL.l - targetHSL.l);
}
var _cache = {};
export function solveColor(input) {
    if (_cache[input]) return _cache[input];
    var targetColor = parseColorToRgb(input);
    var targetHSL = targetColor.hsl();
    function improveInitialSolveResult(initialResult) {
        var A = initialResult.loss;
        var c = 2;
        var A1 = A + 1;
        var a = [
            0.25 * A1,
            0.25 * A1,
            A1,
            0.25 * A1,
            0.2 * A1,
            0.2 * A1
        ];
        return findColorFilters(A, a, c, initialResult.filters, 500);
    }
    function findColorFilters(initialLoss, filters, c, values, iterationsCount) {
        var alpha = 1;
        var gamma = 0.16666666666666666;
        var best = null;
        var bestLoss = Infinity;
        var deltas = new Array(6);
        var highArgs = new Array(6);
        var lowArgs = new Array(6);
        for(var iterationIndex = 0; iterationIndex < iterationsCount; iterationIndex++){
            var ck = c / Math.pow(iterationIndex + 1, gamma);
            for(var i = 0; i < 6; i++){
                deltas[i] = Math.random() > 0.5 ? 1 : -1;
                highArgs[i] = values[i] + ck * deltas[i];
                lowArgs[i] = values[i] - ck * deltas[i];
            }
            var lossDiff = calculateLossForFilters(highArgs, targetColor, targetHSL) - calculateLossForFilters(lowArgs, targetColor, targetHSL);
            for(var i1 = 0; i1 < 6; i1++){
                var g = lossDiff / (2 * ck) * deltas[i1];
                var ak = filters[i1] / Math.pow(initialLoss + iterationIndex + 1, alpha);
                values[i1] = fix(values[i1] - ak * g, i1);
            }
            var loss = calculateLossForFilters(values, targetColor, targetHSL);
            if (loss < bestLoss) {
                best = values.slice(0);
                bestLoss = loss;
            }
        }
        return {
            filters: best,
            loss: bestLoss
        };
        function fix(value, idx) {
            var max = 100;
            if (idx === 2 /* saturate */ ) {
                max = 7500;
            } else if (idx === 4 /* brightness */  || idx === 5 /* contrast */ ) {
                max = 200;
            }
            if (idx === 3 /* hue-rotate */ ) {
                if (value > max) {
                    value %= max;
                } else if (value < 0) {
                    value = max + value % max;
                }
            } else if (value < 0) {
                value = 0;
            } else if (value > max) {
                value = max;
            }
            return value;
        }
    }
    function solveInitial() {
        var A = 5;
        var c = 15;
        var a = [
            60,
            180,
            18000,
            600,
            1.2,
            1.2
        ];
        var best = {
            loss: Infinity,
            filters: [
                0,
                0,
                0,
                0,
                0,
                0
            ]
        };
        for(var i = 0; best.loss > 25 && i < 3; i++){
            var initial = [
                50,
                20,
                3750,
                50,
                100,
                100
            ];
            var result = findColorFilters(A, a, c, initial, 1000);
            if (result.loss < best.loss) {
                best = result;
            }
        }
        return best;
    }
    var result = improveInitialSolveResult(solveInitial());
    var finalResult = convertFiltersListToCSSFilter(result.filters);
    _cache[finalResult] = finalResult;
    return finalResult;
}
